import { render } from "./HealthHistorySection.vue?vue&type=template&id=bdad743c&ts=true"
import script from "./HealthHistorySection.ts?vue&type=script&lang=ts&external"
export * from "./HealthHistorySection.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__